import type { ContentObject } from 'models';
import { BookmarkFillIcon, BookmarkLineIcon, Button } from 'ui';
import { useBookmarkObjectMutation, useUnbookmarkObjectMutation } from '../queries';

type P = {
  contentObject: ContentObject;
};

const BookmarkButton = ({ contentObject }: P) => {
  const { isPending: isBookmarking, mutate: bookmark } = useBookmarkObjectMutation();
  const { isPending: isUnbookmarking, mutate: unbookmark } = useUnbookmarkObjectMutation();

  const handleBookmark = (item: ContentObject) => {
    item.bookmarked
      ? unbookmark({ contentObject: item, type: 'rails' })
      : bookmark({ contentObject: item, type: 'rails' });
  };

  return (
    <Button
      icon={contentObject.bookmarked ? <BookmarkFillIcon /> : <BookmarkLineIcon />}
      loading={isBookmarking || isUnbookmarking}
      onClick={() => {
        handleBookmark(contentObject);
      }}
      type="link-secondary"
    />
  );
};

export default BookmarkButton;
